import { Link, makeStyles } from '@material-ui/core';
import { privacyPolicyUrl, termsOfUseUrl } from '../../../utils';
import React from 'react';

const useStyles = makeStyles((theme: any) => ({
  linksContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-evenly',
    fontSize: theme.fontSizes.onboarding,
  },
}));

export default function PrivacyAndTermsContainer() {
  const classes = useStyles();

  return (
    <div className={classes.linksContainer}>
      <u>
        {' '}
        <Link href={termsOfUseUrl} target="_blank">
          {'Terms of use'}
        </Link>
      </u>
      <u>
        <Link href={privacyPolicyUrl} target="_blank">
          {'Privacy Policy'}
        </Link>
      </u>
    </div>
  );
}
